<template>
  <div class="legal-cases">
    <b-card no-body>
      <b-card-header class="py-2 px-3">
        <!-- <h3 class="mb-0">Credit Application</h3> -->
          <b-row align-v="center">
                    <b-col cols="6">
                        <h3 class="mb-0">
                           Credit Application
                        </h3>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        <b-link href="javascript:void(0)" @click="modals.show_credit_app_full_view = true">
                            <b-icon icon="eye-fill" variant="primary"></b-icon>
                            Full View
                        </b-link>
                    </b-col>
                </b-row>  
      </b-card-header>

      <div v-if="safeCreditApplication.length > 0" class="rounded-bottom">
        <el-table :data="safeCreditApplication" style="width: 100%">
          <!-- Custom column with date above and facility below -->
          <el-table-column label="Date / Facility">
            <template slot-scope="scope">
              <div>
                <div>{{ scope.row.c_date }}</div>
                <small class="text-muted">{{ scope.row.c_facility }}</small>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="unit" label="Unit (RM)" />
          <el-table-column prop="status" label="Status" />
        </el-table>
      </div>

      <div v-else class="bg-light p-3 text-center rounded-bottom">
        <p class="text-xs">No Credit Applications recorded</p>
      </div>
    </b-card>
       <CreditApplicationModal
            :creditApplication="creditApplication" 
            :show_credit_app_full_view.sync="modals.show_credit_app_full_view"
        />
  </div>
</template>

<script>
import { Table, TableColumn } from 'element-ui'
import CreditApplicationModal from '@/views/CustomerProfile/CustomerModals/CreditApplicationModal.vue'

export default {
  name: 'creditApplication',
  props: {
    creditApplication: {
      type: Array,
      default: () => [] // ensures it's never undefined
    }
  },
  components: {
    CreditApplicationModal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
          modals: {
          show_credit_app_full_view: false
        }
    }
  },
  computed: {
    // safeCreditApplication() {
    //   if (!this.creditApplication) return []

    //   return this.creditApplication.map(item => {
    //     // Normalize the amount
    //     let amount = parseFloat(item.c_amount)
    //     const formattedAmount = isNaN(amount)
    //     ? ''
    //     : 'RM ' + amount.toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

    //     // map statuses
    //     let status = item.c_status
    //      if (this._gAuth.isAppSas()) {
    //       if (status === 'Approved by FI') status = 'A'
    //       else if (status === 'Pending decision by FI') status = 'P'
    //     }

    //     return {
    //       c_date: item.c_date || '',
    //       c_facility: item.c_facility || '',
    //       unit: formattedAmount,
    //       status
    //     }
    //   })
    // }
  safeCreditApplication() {
      if (!this.creditApplication) return [];

      return this.creditApplication.map(item => {
      let amount = parseFloat(item.c_amount);
      const formattedAmount = isNaN(amount)
        ? ""
        : "RM " +
          amount.toLocaleString("en-MY", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

        // map statuses
        let status = item.c_status
        if (status.toLowerCase() === "approved by fi") status = "A";
        else if (status.toLowerCase().includes("pending decision by fi")) status = "P";

        return {
          c_date: item.c_date || "",
          c_facility: item.c_facility || "",
          unit: formattedAmount,
          status,
          property_address: item.property_address || "",
          property_status: item.property_status || "",
        };
      });
    },
  },

  methods: {
    /** Format a number as RM currency with 2 decimals **/
    formatAmount(amount) {
      const num = parseFloat(amount);
      if (isNaN(num)) return "";
      return "RM " + num.toLocaleString("en-MY", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>